export default class fun {

  static ClickGoTop() {
    const duration = 300;
    let begin = new Date() - 0;
    let yOffset = window.pageYOffset;
    let timer = setInterval(() => {
      let current = new Date() - begin;
      if (current > duration) {
        clearInterval(timer);
        current = duration;
      }
      window.scrollTo(0, yOffset * (1 - current / duration));
    }, 10);
  }

  static ClickToggle(th) {
    th.classList.toggle("js-open");
  }

  static ClickMenu() {
    const toggleBtn = document.getElementById("menu_button");
    const navView = document.getElementById("menu_area");
    if (toggleBtn.getAttribute("aria-expanded") == "false") {
      document.body.classList.add("js-munu_open-body");
      toggleBtn.setAttribute("aria-expanded", "true");
      navView.setAttribute("aria-hidden", "false");
      toggleBtn.classList.add("js-open");
      toggleBtn.classList.remove("js-close");
      navView.classList.add("js-open");
      navView.classList.remove("js-close");
    } else {
      document.body.classList.remove("js-munu_open-body");
      toggleBtn.setAttribute("aria-expanded", "false");
      navView.setAttribute("aria-hidden", "true");
      toggleBtn.classList.remove("js-open");
      toggleBtn.classList.add("js-close");
      navView.classList.remove("js-open");
      navView.classList.add("js-close");
    }
  }

  static ClickTab(data_tab, th) {
    const parent = th.parentNode;
    const el = parent.children;
    const el_data = parent.dataset.tab;
    for (let i = 0; i < el.length; i++) {
      el[i].classList.remove("js-open");
    }
    th.classList.add("js-open");
    for (let i = 0; i < el.length; i++) {
      if (el[i].classList.contains("js-open")) {
        var index = i;
      }
    }
    const tab_contents = document.querySelectorAll("[data-tab_contents]");
    for (let i = 0, len = tab_contents.length; i < len; ++i) {
      const tab_data = tab_contents[i].dataset.tab_contents;
      if (el_data == tab_data) {
        let tab_child = tab_contents[i].children;
        for (var ii = 0; ii < tab_child.length; ii++) {
          tab_child[ii].classList.remove("js-open");
        }
        tab_child[index].classList.add("js-open");
      }
    }
  }

  static ClickModal(data_modal, th) {
    th.classList.toggle("js-open");
    const this_data = th.dataset.modal;
    const modal_contents = document.querySelectorAll("[data-modal_contents]");
    for (let i = 0, len = modal_contents.length; i < len; ++i) {
      const modal_contents_data = modal_contents[i].dataset.modal_contents;
      if (this_data == modal_contents_data) {
        if (th.classList.contains("js-open")) {
          modal_contents[i].classList.add("js-open");
          document.body.classList.add("js-moda-body");
        } else {
          modal_contents[i].classList.remove("js-open");
        }
      }
    }
    const modal_close = document.querySelectorAll("[data-modal_close]");
    for (let i = 0, len = modal_close.length; i < len; ++i) {
      const modal_close_data = modal_close[i].dataset.modal_close;
      modal_close[i].addEventListener("click", e => {
        if (this_data == modal_close_data) {
          th.classList.remove("js-open");
          modal_contents[i].classList.remove("js-open");
          document.body.classList.remove("js-moda-body");
        }
      });
    }
  }

  static SmoothLink() {
    // スクロール位置に持たせる高さ
    let headH = document.getElementById('header-bar').clientHeight;
    // 最低必要な高さ
    const minH = 80;
    if (headH < minH || headH === undefined) {
      headH = minH;
    } else {
      headH = headH + 20;
    }
    // 別ページのスムーズリンク
    const urlHash = location.hash;
    if (urlHash) {
      window.scrollTo(0, 0);
      const interval = 10;
      const divisor = 8;
      const range = divisor / 2 + 1;
      let toY;
      let nowY = window.pageYOffset;
      const target = document.querySelector(urlHash);
      const targetRect = target.getBoundingClientRect();
      const targetY = targetRect.top + nowY - headH;
      setTimeout(function doScroll2(){
        toY = nowY + Math.round((targetY - nowY) / divisor);
        window.scrollTo(0, toY);
        nowY = toY;
        if (document.body.clientHeight - window.innerHeight < toY) {
          window.scrollTo(0, document.body.clientHeight);
          return;
        }
        if (toY >= targetY + range || toY <= targetY - range) {
          window.setTimeout(doScroll2, interval);
        } else {
          window.scrollTo(0, targetY);
        }
      }, 200);
    }
    // 同ページのスムーズリンク
    const links = document.querySelectorAll('a[href^="#"]');
    for (let i = 0; i < links.length; i++) {
      links[i].addEventListener("click", e => {
        const target = e.target;
        // clickした要素がclass属性、js-not-smooth-scrollを含む場合は処理を中断
        if (target.classList.contains("js-not-smooth-scroll")) return;
        e.preventDefault();
        const targetId = target.hash;
        const targetElement = document.querySelector(targetId);
        // 画面上部から要素までの距離
        const rectTop = targetElement.getBoundingClientRect().top;
        // 現在のスクロール距離
        const offsetTop = window.pageYOffset;
        const top = rectTop + offsetTop - headH;
        window.scrollTo({
          top,
          behavior: "smooth"
        });
      });
    }
  }
}

function PagerFetch(e) {
  const ajaxurl =
      window.location.protocol +
      "//" +
      window.location.host +
      "/wp-admin/admin-ajax.php",
    url = e.getAttribute("href"),
    fetch_catid = document.querySelector("[data-pager_fetch_catid"),
    fetch_template = document.querySelector("[data-pager_fetch_template"),
    result = url.split("/").filter(e => Boolean(e));
  let paged = null;
  if (isFinite(result[result.length - 1])) {
    paged = result[result.length - 1];
  } else {
    paged = 1;
  }
  if (self.fetch) {
    const params = new URLSearchParams();
    const articleOuter = document.querySelector('[data-receive="pager_fetch"]');
    params.append("paged", paged);
    params.append("action", "pager_fetch");
    params.append("catid", fetch_catid.dataset.pager_fetch_catid);
    params.append("template", fetch_template.dataset.pager_fetch_template);
    const first_text = articleOuter.innerHTML;
    window.history.replaceState(first_text, null, url);
    fetch(ajaxurl, {
      method: "POST",
      credentials: "same-origin",
      body: params
    })
      .then(response => {
        return response.text();
      })
      .then(
        text => {
          articleOuter.textContent = "";
          articleOuter.insertAdjacentHTML("afterbegin", text);
        //   ClickPager("[data-pager]");
        //   DataSrc("[data-src]");
        //   DataScroll("[data-scroll]");
          window.location.hash = "content";
          window.history.replaceState(text, null, url);
        },
        error => {
          console.log(error);
        }
      );
  } else {
    alert(
      "ご使用のブラウザはサポートしていません。Chrome, firefox, Edge等の最新版のブラウザをご使用下さい"
    );
  }
  return false;
}